import { Fields } from '@app/common/configurable-wizards';

export enum PasswordValidationRules {
  required = 'required',
  minLength = 'minLength',
  maxLength = 'maxLength',
  firstCharAlphabetic = 'firstCharAlphabetic',
  anyAlphabetic = 'anyAlphabetic',
  anyLowerCase = 'anyLowerCase',
  noLowerCase = 'noLowerCase',
  anyUpperCase = 'anyUpperCase',
  noUpperCase = 'noUpperCase',
  anyNumber = 'anyNumber',
  noNumber = 'noNumber',
  anySpecialChar = 'anySpecialChar',
  noSpecialChar = 'noSpecialChar',
}

export type PolicySettings = NonNullable<Fields['Password']['passwordPolicy']>;
